<template>
  <header>
    <div
      class="nav-container"
      v-if="
        route.path != '/nieuwsbericht' &&
        route.path != '/regeling' &&
        route.path != '/onze-bevindingen-uitschrijven' &&
        route.path != '/onze-bevindingen/nieuwsbrief'
      "
    >
      <div v-bind:class="{ show: isExpanded }">
        <div class="menu-buttons" :class="!isVind ? 'portalmenu-buttons' : ''">
          <Slide
            right
            class="burger-menu"
            :class="!isVind ? 'portals-burgermenu' : ''"
            :closeOnNavigation="true"
            v-if="!displayCustomerSelection"
          >
            <router-link :to="{ name: 'SearchGrants' }" v-if="isLoggedIn">
              <q-btn
                :label="t('navbar.search_schemes')"
                class="burgermenu-button bold-font"
                flat
                no-caps
              >
              </q-btn>
            </router-link>
            <router-link :to="{ name: 'News' }" v-if="isLoggedIn">
              <q-btn
                :label="t('navbar.search_news')"
                class="burgermenu-button bold-font"
                flat
                no-caps
              >
              </q-btn>
            </router-link>
            <router-link :to="{ name: 'HomePage' }" v-if="isLoggedIn && isVind">
              <q-btn
                :label="t('navbar.dashboard')"
                class="burgermenu-button bold-font"
                flat
                no-caps
              >
              </q-btn>
            </router-link>
            <router-link
              :to="{ name: 'UserProfile', params: { tab: 'myBasicDetails' } }"
              v-if="isLoggedIn"
              @click="tabValue('myBasicDetails')"
            >
              <q-btn
                :label="t('navbar.details')"
                class="burgermenu-button bold-font"
                flat
                no-caps
              >
              </q-btn>
            </router-link>
            <router-link
              :to="{ name: 'UserProfile', params: { tab: 'newsletter' } }"
              v-if="isLoggedIn && isVind"
              @click="tabValue('newsletter')"
            >
              <q-btn
                :label="t('navbar.profile_and_newsletter')"
                class="burgermenu-button bold-font"
                flat
                no-caps
              >
              </q-btn>
            </router-link>
            <router-link
              :to="{
                name: 'UserProfile',
                params: { tab: 'savedItemsSchemes' },
              }"
              v-if="isLoggedIn && isVind"
              @click="tabValue('savedItemsSchemes')"
            >
              <q-btn
                :label="t('navbar.saved_items')"
                class="burgermenu-button bold-font"
                flat
                no-caps
              >
              </q-btn>
            </router-link>
            <router-link
              :to="{ name: 'UserProfile', params: { tab: 'hiddenSchemes' } }"
              v-if="isLoggedIn && isVind"
              @click="tabValue('hiddenSchemes')"
            >
              <q-btn
                :label="t('navbar.hidden_schemes')"
                class="burgermenu-button bold-font"
                flat
                no-caps
              >
              </q-btn>
            </router-link>
            <router-link
              :to="{ name: 'UserProfile', params: { tab: 'userManagement' } }"
              v-if="isLoggedIn && isVind"
              @click="tabValue('customersBasicDetails')"
            >
              <q-btn
                :label="t('navbar.account_management')"
                class="burgermenu-button bold-font"
                flat
                no-caps
              >
              </q-btn>
            </router-link>
            <q-btn
              v-if="isLoggedIn && showSasButton"
              label="SAS"
              class="burgermenu-button bold-font"
              flat
              no-caps
              @click="redirectToSas()"
            >
            </q-btn>
            <router-link :to="{ name: 'Login' }" v-if="isLoggedIn">
              <q-btn
                class="burgermenu-button bold-font"
                flat
                no-caps
                @click="logout"
              >
                <i class="fa-solid fa-right-from-bracket q-mr-sm"></i
                >{{ t("navbar.log_out") }}
              </q-btn>
            </router-link>
          </Slide>

          <div class="largescreen-buttons">
            <div class="logo-header">
              <a
                v-if="isVind"
                href="/search-grants"
                :aria-label="t('navbar.logo_aria')"
              >
                <div :class="languageCode == 'nl' ? 'logo' : 'logo-german'" />
              </a>
              <a
                v-else
                :href="getCustomerBaseUrl()"
                :aria-label="getCustomerLogoAria()"
              >
                <div class="logo" />
              </a>
            </div>
            <div class="all-menu-buttons" v-if="!displayCustomerSelection">
              <div class="leftmenu-buttons">
                <router-link
                  v-if="isLoggedIn"
                  :aria-label="t('navbar.go_to_the_grant_search_page')"
                  :to="
                    isVind || isSKS
                      ? { name: 'SearchGrants' }
                      : { name: 'PortalSearchGrants' }
                  "
                  class="navmenu-link"
                >
                  <q-btn
                    flat
                    color="white"
                    :label="
                      isVind || isSKS
                        ? t('navbar.search_schemes')
                        : t('navbar.my_overview')
                    "
                    no-caps
                    class="navmenu-link q-ml-sm"
                    :class="
                      route.name == 'SearchGrants' ||
                      route.name == 'PortalSearchGrants'
                        ? 'current-route'
                        : ''
                    "
                  >
                  </q-btn>
                </router-link>
                <router-link
                  v-if="isLoggedIn"
                  :aria-label="t('navbar.go_to_news_page')"
                  :to="{ name: 'News' }"
                  class="navmenu-link"
                >
                  <q-btn
                    class="navmenu-link q-ml-sm"
                    flat
                    color="white"
                    no-caps
                    :label="
                      isVind || isSKS
                        ? t('navbar.search_news')
                        : t('search_news.news')
                    "
                    :class="route.name == 'News' ? 'current-route' : ''"
                  >
                    <q-badge
                      v-if="displayNumberOfNewsResults"
                      class="results-badge"
                      :label="resultsCount"
                      >{{ resultCount }}</q-badge
                    >
                  </q-btn>
                </router-link>
                <router-link
                  v-if="isLoggedIn && isVind"
                  :aria-label="t('navbar.go_to_home_page')"
                  :to="{ name: 'HomePage' }"
                  class="navmenu-link"
                >
                  <q-btn
                    flat
                    color="white"
                    :label="t('navbar.dashboard')"
                    no-caps
                    class="navmenu-link q-ml-sm"
                    :class="route.name == 'HomePage' ? 'current-route' : ''"
                  >
                  </q-btn>
                </router-link>
                <router-link
                  v-if="isLoggedIn && hasObRole && locale == 'nl'"
                  :to="{ name: 'OnzeExportPage', params: { tab: 'stats' } }"
                  class="navmenu-link"
                >
                  <q-btn
                    flat
                    color="white"
                    label="BeVINDingen "
                    no-caps
                    class="navmenu-link q-ml-sm"
                    :class="
                      route.name == 'OnzeExportPage' ? 'current-route' : ''
                    "
                  >
                  </q-btn>
                </router-link>
                <router-link
                  v-if="isLoggedIn && hasMailingRole && locale == 'nl'"
                  :aria-label="t('navbar.mailing')"
                  :to="{ name: 'Mailing' }"
                  class="navmenu-link"
                >
                  <q-btn
                    flat
                    color="white"
                    :label="t('navbar.mailing')"
                    no-caps
                    class="navmenu-link q-ml-sm"
                    :class="route.name == 'Mailing' ? 'current-route' : ''"
                  >
                  </q-btn>
                </router-link>
                <q-btn
                  v-if="isLoggedIn && showSasButton"
                  label="SAS"
                  class="navmenu-link q-ml-sm"
                  flat
                  color="white"
                  no-caps
                  @click="redirectToSas()"
                >
                </q-btn>
              </div>
              <div class="right-menu-buttons row">
                <div class="q-ml-sm">
                  <q-btn-dropdown
                    flat
                    color="white"
                    v-if="isLoggedIn && !isAutoLog"
                    icon="fa-solid fa-circle-user"
                    class="navmenu-link"
                    id="v-step-13"
                    :aria-label="t('navbar.menu_buttons')"
                  >
                    <q-list class="nav-list-largescreen">
                      <router-link
                        :to="{
                          name: 'UserProfile',
                          params: { tab: 'myBasicDetails' },
                        }"
                        class="navmenu-link"
                        style="text-decoration: none; color: black"
                        @click="tabValue('myBasicDetails')"
                        v-if="!isSKS"
                      >
                        <q-item clickable v-close-popup>
                          <q-item-section>
                            {{ t("navbar.details") }}
                          </q-item-section>
                        </q-item>
                      </router-link>

                      <router-link
                        v-if="isVind"
                        :to="{
                          name: 'UserProfile',
                          params: { tab: 'newsletter' },
                        }"
                        class="navmenu-link"
                        style="text-decoration: none; color: black"
                        @click="tabValue('newsletter')"
                      >
                        <q-item clickable v-close-popup>
                          <q-item-section
                            >{{ t("navbar.profile_settings") }}
                          </q-item-section>
                        </q-item>
                      </router-link>

                      <router-link
                        v-if="isVind"
                        :to="{
                          name: 'UserProfile',
                          params: { tab: 'nieuwsbrief' },
                        }"
                        class="navmenu-link"
                        style="text-decoration: none; color: black"
                        @click="tabValue('nieuwsbrief')"
                      >
                        <q-item clickable v-close-popup>
                          <q-item-section
                            >{{ t("navbar.newsletter_settings") }}
                          </q-item-section>
                        </q-item>
                      </router-link>

                      <router-link
                        :to="{
                          name: 'UserProfile',
                          params: { tab: 'savedItemsSchemes' },
                        }"
                        v-if="isVind || isSKS"
                        class="navmenu-link"
                        style="text-decoration: none; color: black"
                        @click="tabValue('savedItemsSchemes')"
                      >
                        <q-item clickable v-close-popup>
                          <q-item-section v-if="isVind">
                            {{ t("navbar.saved_items") }}
                          </q-item-section>
                          <q-item-section v-else>{{
                            t("navbar.favorites")
                          }}</q-item-section>
                        </q-item>
                      </router-link>

                      <router-link
                        v-if="isVind || isSKS"
                        :to="{
                          name: 'UserProfile',
                          params: { tab: 'hiddenSchemes' },
                        }"
                        class="navmenu-link"
                        style="text-decoration: none; color: black"
                        @click="tabValue('hiddenSchemes')"
                      >
                        <q-item clickable v-close-popup>
                          <q-item-section>
                            {{ t("navbar.hidden_schemes") }}
                          </q-item-section>
                        </q-item>
                      </router-link>

                      <router-link
                        v-if="showAdminPanel && isVind"
                        :to="{
                          name: 'UserProfile',
                          params: { tab: 'accountgegevens' },
                        }"
                        @click="tabValue('accountgegevens')"
                        class="navmenu-link"
                        style="text-decoration: none; color: black"
                      >
                        <q-item clickable v-close-popup>
                          <q-item-section>
                            {{ t("navbar.account_management") }}
                          </q-item-section>
                        </q-item>
                      </router-link>

                      <router-link
                        flat
                        color="white"
                        :to="{ name: 'Login' }"
                        class="navmenu-link"
                        style="text-decoration: none; color: black"
                      >
                        <q-item clickable v-close-popup>
                          <q-item-section @click="logout">
                            {{ t("navbar.log_out") }}
                          </q-item-section>
                        </q-item>
                      </router-link>
                    </q-list>
                  </q-btn-dropdown>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import store from "../store/index.js";
import { Slide } from "vue3-burger-menu";
import { computed, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import authService from "../services/auth.service.js";

export default {
  name: "NavMenu",
  components: {
    Slide,
  },
  setup() {
    const { t, locale } = useI18n();

    const hasObRole = computed(() => store.state.auth.authUser.hasObRole);
    const hasMailingRole = computed(
      () => store.state.auth.authUser.hasMailingRole
    );
    const displayCustomerSelection = computed({
      get: () => store.state.auth.customerSelectionEnabled,
    });

    const route = useRoute();
    const router = useRouter();

    const logout = async () => {
      await authService.logout(true);
      router.push({
        name: "Login",
      });
    };

    const collapse = () => {
      this.isExpanded = false;
    };

    const toggle = () => {
      this.isExpanded = !this.isExpanded;
    };

    const isLoggedIn = computed({
      get: () => store.state.auth.isLoggedIn,
    });

    const showAdminPanel = computed({
      get: () => store.state.auth.authUser.showAdminPanel,
    });

    const isExpanded = ref(false);

    const isVind = computed({
      get: () => store.state.auth.env === 0 || store.state.auth.env === 40,
    });

    const isAutoLog = computed({
      get: () => store.state.auth.env === 50 || store.state.auth.env === 60,
    });

    const resultCount = computed({
      get: () => store.state.newsSearch.resultsCount,
    });

    const displayNumberOfNewsResults = computed({
      get: () => store.state.advancedSearch.displayNumberOfNewsResults,
    });

    const showSasButton = computed({
      get: () =>
        store.state.auth.authUser.customerHasSas &&
        store.state.auth.authUser.hasSas,
    });

    const redirectToSas = () => {
      window.open(process.env.VUE_APP_SAS_BASE_URL, "_blank");
    };
    const setThemeToContrast = () => {
      store.commit("user/setIsSelectedThemeContrast", true);
      localStorage.setItem("themeContrast", true);
    };

    const setNormalTheme = () => {
      store.commit("user/setIsSelectedThemeContrast", false);
      localStorage.setItem("themeContrast", false);
    };

    const toggleTheme = () => {
      if (isContrastTheme.value == false || isContrastTheme.value == "false") {
        store.commit("user/setIsSelectedThemeContrast", true);
        localStorage.setItem("themeContrast", true);
      } else {
        store.commit("user/setIsSelectedThemeContrast", false);
        localStorage.setItem("themeContrast", false);
      }
    };

    const isContrastTheme = computed({
      get: () => store.state.user.isSelectedThemeContrast,
    });
    const tabValue = (tabName) => {
      if (tabName == "savedItemsSchemes") {
        store.commit("user/updateIsClickedSavedItems", true);
        store.commit("user/updateIsClickedUserManagement", false);
        store.commit("user/updateIsClickedNewsletter", false);
        store.commit("user/updateIsClickedMenuItemSchemes", true);
        store.commit("user/updateIsClickedMenuItemCustomersBasic", false);
        store.commit("user/updateIsClickedMenuItemAudiences", false);
      }
      if (tabName == "accountgegevens") {
        store.commit("user/updateIsClickedSavedItems", false);
        store.commit("user/updateIsClickedUserManagement", true);
        store.commit("user/updateIsClickedNewsletter", false);
        store.commit("user/updateIsClickedMenuItemCustomersBasic", true);
        store.commit("user/updateIsClickedMenuItemAudiences", false);
        store.commit("user/updateIsClickedMenuItemSchemes", false);
      }
      if (tabName == "newsletter") {
        store.commit("user/updateIsClickedMenuItemAudiences", true);
        store.commit("user/updateIsClickedSavedItems", false);
        store.commit("user/updateIsClickedNewsletter", true);
        store.commit("user/updateIsClickedUserManagement", false);
        store.commit("user/updateIsClickedMenuItemSchemes", false);
        store.commit("user/updateIsClickedMenuItemCustomersBasic", false);
      }
      if (
        tabName == "hiddenSchemes" ||
        tabName == "nieuwsbrief" ||
        tabName == "myBasicDetails"
      ) {
        store.commit("user/updateIsClickedSavedItems", false);
        store.commit("user/updateIsClickedUserManagement", false);
        store.commit("user/updateIsClickedNewsletter", false);
        store.commit("user/updateIsClickedMenuItemSchemes", false);
        store.commit("user/updateIsClickedMenuItemCustomersBasic", false);
        store.commit("user/updateIsClickedMenuItemAudiences", false);
        store.commit("user/updateIsClickedMenuItemPurposes", false);
        store.commit("user/updateIsClickedMenuItemLocations", false);
      }
    };

    const customer = computed({
      get: () => store.state.auth.customer,
    });

    const getCustomerBaseUrl = () => `${customer.value.baseUrl}/search-grants`;

    const getCustomerLogoAria = () =>
      customer.value.customerPortalName
        ? `${t("navbar.logo_aria")} ${customer.value.customerPortalName}`
        : t("navbar.logo_aria");

    const isSKS = computed({
      get: () => store.state.auth.env === 30,
    });

    const languageCode = ref(useI18n().locale.value);

    return {
      languageCode,
      isSKS,
      hasMailingRole,
      getCustomerBaseUrl,
      getCustomerLogoAria,
      customer,
      hasObRole,
      router,
      route,
      toggleTheme,
      isContrastTheme,
      tabValue,
      setNormalTheme,
      setThemeToContrast,
      displayNumberOfNewsResults,
      resultCount,
      logout,
      isLoggedIn,
      collapse,
      toggle,
      isExpanded,
      showAdminPanel,
      isVind,
      isAutoLog,
      locale,
      showSasButton,
      redirectToSas,
      displayCustomerSelection,
    };
  },
};
</script>
